module.exports = __webpack_public_path__ + "img/UTFHNH-3.b779718f.jpg";